import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import CodeValue from '~/components/patterns/values/CodeValue';
import Ellipsis from '~/components/patterns/values/Ellipsis';
import SmallTable from '~/components/atoms/issues/components/detailsPlaceholders/SmallTable';



const messages = defineMessages({
	exampleUrl: {
		id: 'ui.platformIssueDetail.domain.columns.exampleUrl',
	},
	response: {
		id: 'ui.platformIssueDetail.domain.columns.response',
	},
});



type Props = {
	issue: {
		context: {
			sample_urls: ReadonlyArray<string>,
		},
	},
	tableWidth: number,
};

const SampleSoft404UrlsTable: React.FC<Props> = (props) => {
	const {
		issue,
		tableWidth,
	} = props;

	const firstColumnWidth = Math.ceil(tableWidth * 0.75);

	return (
		<SmallTable
			columns={[
				{
					hasData: () => true,
					render: {
						cell: ({ row }) => {
							return (
								<Ellipsis>
									{row}
								</Ellipsis>
							);
						},
						header: () => <FormattedMessage {...messages.exampleUrl} />,
					},
					width: firstColumnWidth,
				},
				{
					hasData: () => true,
					render: {
						cell: () => {
							return (
								<Ellipsis>
									<CodeValue>
										200
									</CodeValue>
								</Ellipsis>
							);
						},
						header: () => <FormattedMessage {...messages.response} />,
					},
					width: tableWidth - firstColumnWidth - 2,
				},
			]}
			rows={issue.context.sample_urls}
			tableWidth={tableWidth}
		/>
	);
};



export default React.memo(SampleSoft404UrlsTable);
